import Swiper from "swiper";
import SwiperCore, {
  Navigation,
  Autoplay,
  Pagination,
  Lazy,
} from "swiper/core";
SwiperCore.use([Navigation, Autoplay, Pagination, Lazy]);

export default function  catalogSliders(){


const swiperBannerItem = new Swiper(
  document.querySelector(".banner__slider "),
  {
    slidesPerView: 1,
    loop: true,
    slideClass: "banner__img",
    pagination: {
      el: ".swiper-pagination-banner",
      clickable: true,
    },

    navigation: {
      nextEl: ".banner__next",
      prevEl: ".banner__prev",
    },
    grabCursor: true,
  }
);

const swiperInterested = new Swiper(
  document.querySelector(".viewed__slider "),
  {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    slideClass: "catalog-item ",
    navigation: {
      nextEl: ".slider__next-viewed",
      prevEl: ".slider__prev-viewed",
    },
    preloadImages: false,
    lazy: true,
    grabCursor: true,
    breakpoints: {
      1920: {
        slidesPerView: 7,
      },

      1190: {
        slidesPerView: 5,
      },
      1024: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
    },
  }
);
catalogItemSlider();

}
function catalogItemSlider() {
  const swiperProductItem = new Swiper(
    document.querySelector('[data-swiper="id-1"]'),
    {
      slidesPerView: 1,
      // spaceBetween: 10,
      loop: true,
      slideClass: "catalog-item__image",
      preloadImages: false,
      lazy: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".slider__next-catalog-item-id-1",
        prevEl: ".slider__prev-catalog-item-id-1",
      },
      grabCursor: true,
    }
  );
}
